// extracted by mini-css-extract-plugin
export default {"header":"Header_header__HXQOm","headerToggle":"Header_headerToggle__8g6aL","dark":"Header_dark__5Fs0T","light":"Header_light__1SvF+","headerImage":"Header_headerImage__oNSLc"};